<template>
  <my-orders />
</template>

<script>
import MyOrders from '@/components/reports/MyOrders';

export default {
  name: 'Reports',
  components: {
    MyOrders,
  },
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ReportsPage.vue